import React from 'react'
import HeadNav from '../../../../head-nav/head-nav'
import HeadNavLink from '../../../../head-nav/head-nav-link/head-nav-link'
import { withRouter } from 'react-router-dom'

const Nav = ({ classes, className, location, match }) => (
  <HeadNav className={className}>
    <HeadNavLink path={`/pupil/${match.params.pupilId}`}>Profile</HeadNavLink>
    <HeadNavLink path={`/pupil/${match.params.pupilId}/work`}>
      Evidence bank
    </HeadNavLink>
    <HeadNavLink path={`/pupil/${match.params.pupilId}/comments`}>
      Comments
    </HeadNavLink>
    <HeadNavLink path={`/pupil/${match.params.pupilId}/assessment`}>
      Moderation portfolio
    </HeadNavLink>
  </HeadNav>
)

export default withRouter(Nav)
